import { useEffect, useRef } from 'react';
import { useApp } from '../common/AppProvider';
import { getAuthenticationStatus } from '../api';

const useAuthentication = (connectorId?: string) => {
    const { language, connectors } = useApp();
    const interval = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        return () => {
            if (interval.current) {
                clearInterval(interval.current);
            }
        };
    }, []);

    const onAuthenticate = (
        triggerId: string | null,
        actionId: string | null,
        onAuthenticated: () => void,
    ) => {
        if (!connectorId) {
            return;
        }

        const oauthWindow = window.open(
            `${window.origin}/tool/${triggerId || actionId}/authorize?language=${language}`,
            connectors[connectorId].displayName,
            'width=500,height=700',
        );

        if (oauthWindow) {
            if (interval.current) {
                clearInterval(interval.current);
            }

            let iterations = 0;

            interval.current = setInterval(async () => {
                iterations++;

                const response = await getAuthenticationStatus();

                if (
                    (triggerId && response[connectorId]?.[triggerId]) ||
                    (actionId && response[connectorId]?.[actionId])
                ) {
                    clearInterval(interval.current!);
                    onAuthenticated();
                }

                if (iterations >= 90 && interval.current) {
                    clearInterval(interval.current);
                }
            }, 2000);
        }
    };

    return {
        onAuthenticate,
    };
};

export default useAuthentication;
